import { FuelTag, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import React, { FC } from 'react';
import { brlTextToCurrency } from 'utils';
import { isEmpty } from 'utils/validate';
import GenericEmptyState from '../GenericEmptyState';
import GenericInfoItem from '../GenericInfoItem';
import MainDestination from './MainDestination';

const TravelHistory: FC<{ data: ITruckerProfileProps }> = ({ data }) => {
  const hasMainDestination =
    !isEmpty(data?.trucker?.mainDestination?.city) && !isEmpty(data?.trucker?.mainDestination?.state);
  const hasTravelHistoryAmmount = data?.journey?.total > 0;
  const hasCompaniesAmmount = data?.journey?.totalCompanies > 0;
  const hasAvarageValue =
    !isEmpty(data?.journey?.averageValueTrips) && parseFloat(data?.journey?.averageValueTrips) > 0;
  const hasMaxValue = !isEmpty(data?.journey?.maxValueTrips) && parseFloat(data?.journey?.maxValueTrips) > 0;

  const hasItemBelowMainDestination = hasTravelHistoryAmmount || hasCompaniesAmmount || hasMaxValue || hasAvarageValue;
  const hasItemBelowTravelsAmmount = hasCompaniesAmmount || hasMaxValue || hasAvarageValue;
  const hasItemBelowCompnaiesAmmount = hasMaxValue || hasAvarageValue;
  const hasItemBelowMaxValues = hasAvarageValue;

  const isEmptyState =
    !hasMainDestination && !hasTravelHistoryAmmount && !hasCompaniesAmmount && !hasAvarageValue && !hasMaxValue;

  return (
    <FuelFlex
      defaultProps={{
        flexDirection: 'column',
        customPadding: `${DS_TOKENS.spacing.km10} ${DS_TOKENS.spacing.km8} 0`,
      }}
    >
      <FuelFlex defaultProps={{ justifyContent: 'space-between', customMargin: `0 0 ${DS_TOKENS.spacing.km6}` }}>
        <FuelTypography size="heading-sm" weight="bold" data-testid="travel-history-title">
          Histórico
        </FuelTypography>
        {!isEmptyState && (
          <FuelTag label="últimos 12 meses" shape="rectangle" uppercase highlight data-testid="travel-history-tag" />
        )}
      </FuelFlex>
      {isEmptyState ? (
        <GenericEmptyState textContent="Ainda não possui histórico de viagem na Fretebras." />
      ) : (
        <>
          {hasMainDestination && (
            <MainDestination
              mainDestination={data?.trucker?.mainDestination}
              hasItemBelow={hasItemBelowMainDestination}
            />
          )}

          {hasTravelHistoryAmmount && (
            <GenericInfoItem title="Viagens realizadas" displayDivider={hasItemBelowTravelsAmmount}>
              <FuelTypography weight="medium">
                {data.journey.total} {data.journey.total > 1 ? 'viagens' : 'viagem'}
              </FuelTypography>
            </GenericInfoItem>
          )}

          {hasCompaniesAmmount && (
            <GenericInfoItem title="Empresas atendidas" displayDivider={hasItemBelowCompnaiesAmmount}>
              <FuelTypography weight="medium">
                {data.journey.totalCompanies} {data.journey.totalCompanies > 1 ? 'empresas' : 'empresa'}
              </FuelTypography>
            </GenericInfoItem>
          )}

          {hasMaxValue && (
            <GenericInfoItem title="Maior valor de carga" displayDivider={hasItemBelowMaxValues}>
              <FuelTypography weight="medium">{brlTextToCurrency(data.journey.maxValueTrips)}</FuelTypography>
            </GenericInfoItem>
          )}

          {hasAvarageValue && (
            <GenericInfoItem title="Valor médio das cargas" displayDivider={false}>
              <FuelTypography weight="medium">{brlTextToCurrency(data.journey.averageValueTrips)}</FuelTypography>
            </GenericInfoItem>
          )}
        </>
      )}
    </FuelFlex>
  );
};

export default TravelHistory;
